import React from "react";
import "./FooterStyles.css";
import {
  FaFacebookF,
  FaYoutube,
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt
} from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">

      <div className="footer-container">

        {/* COMPANY */}
        <div className="footer-col">
          <h3>Zuluwhiskey Shipping</h3>
          <p>
            Reliable global shipping and logistics solutions. We deliver your
            goods safely across borders with speed, security, and efficiency.
          </p>

          <div className="footer-socials">
            <a href="#"><FaFacebookF /></a>
            <a href="#"><FaYoutube /></a>
            <a href="mailto:zulushipping@gmail.com"><FaEnvelope /></a>
          </div>
        </div>

        {/* SERVICES */}
        <div className="footer-col">
          <h4>Our Services</h4>
          <ul>
            <li>International Shipping</li>
            <li>Heavy Cargo Transport</li>
            <li>Warehousing</li>
            <li>Doorstep Delivery</li>
          </ul>
        </div>

        {/* QUICK LINKS */}
        <div className="footer-col">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/track">Track Shipment</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        {/* CONTACT */}
        <div className="footer-col">
          <h4>Contact Info</h4>

          <p><FaMapMarkerAlt /> Monrovia, Liberia</p>
          <p><FaPhoneAlt /> +231 777 272 609</p>
          <p><FaEnvelope /> zulushipping@gmail.com</p>

        </div>

      </div>

      {/* BOTTOM BAR */}
      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} Zuluwhiskey Shipping Company. All Rights Reserved.
        </p>
      </div>

    </footer>
  );
};

export default Footer;